import { formatMoney, unformat } from '../accounting/accounting';
const defaultOptions = {
    cents: true,
    decimal: '.',
    thousand: ',',
    subunitToUnit: 100,
    symbol: '$',
    symbolFirst: true
};
const toMoney = (number, options) => {
    var _a, _b, _c, _d, _e, _f;
    const config = {
        cents: (_a = options === null || options === void 0 ? void 0 : options.cents) !== null && _a !== void 0 ? _a : defaultOptions.cents,
        decimal: (_b = options === null || options === void 0 ? void 0 : options.decimal) !== null && _b !== void 0 ? _b : defaultOptions.decimal,
        thousand: (_c = options === null || options === void 0 ? void 0 : options.thousand) !== null && _c !== void 0 ? _c : defaultOptions.thousand,
        subunitToUnit: (_d = options === null || options === void 0 ? void 0 : options.subunitToUnit) !== null && _d !== void 0 ? _d : defaultOptions.subunitToUnit,
        symbol: (_e = options === null || options === void 0 ? void 0 : options.symbol) !== null && _e !== void 0 ? _e : defaultOptions.symbol,
        symbolFirst: (_f = options === null || options === void 0 ? void 0 : options.symbolFirst) !== null && _f !== void 0 ? _f : defaultOptions.symbolFirst
    };
    const { cents, decimal, subunitToUnit, symbol, symbolFirst, thousand } = config;
    const precision = cents ? Math.log10(subunitToUnit) : 0;
    let format = '%v';
    if (symbol) {
        format = symbolFirst ? '%s%v' : '%v %s';
    }
    const settings = { format, decimal, symbol, precision, thousand };
    return formatMoney(number, settings);
};
const toNumber = (number, options) => {
    var _a;
    const decimal = (_a = options === null || options === void 0 ? void 0 : options.decimal) !== null && _a !== void 0 ? _a : defaultOptions.decimal;
    return unformat(number, decimal);
};
export { toNumber, toMoney };
//# sourceMappingURL=money.js.map